import React,{Component} from 'react';
import {PDFViewer,Document,Page,Text,View,Image} from '@react-pdf/renderer';
import {Typography} from '@material-ui/core';
import Firma from './Firma Brown.png';
import DBHandler from '../DBHandler';
import Logo from '../logobrown.png';

let URLBASE = 'retenciones/';

export default class TasaMunicipal extends Component{
    constructor(props){
        super(props);
        this.state={
            nroReten:'',
            op:'',
            fechaop:'',
            importeop:'',
            alicuota:'',
            importereten:'',
            fechapago:'',
            cuit:'',
            razon:'',
            calle:'',
            callenro:'',
            piso:'',
            dpto:'',
            localidad:'',
            provincia:'',
            pais:'',
            concepto:'',
            comprobantes:[],
            ejercicio:props.ejercicio,
            importeescrito:'',
        }
        this.db = new DBHandler();
        

        if( props.op !== undefined && props.op !== null){
            this.pedirDatos.bind(this)(props.op,props.tipo_deduc,props.ejercicio,props.tabla);
        }
    }

    componentWillReceiveProps(props){
        if( props.op !== undefined && props.op !== null){
            this.pedirDatos.bind(this)(props.op,props.tipo_deduc,props.ejercicio,props.tabla);
            this.setState({ejercicio:props.ejercicio})
        }
    }

    pedirDatos(op,deduc,ejercicio,tabla){
        this.db.enviarPeticion(
            this.cargarDatos.bind(this),
            URLBASE + 'devolverRetencion',
            'POST',
            {
                'nro_op':op,
                'codigo_deduc':deduc,
                'ejercicio':ejercicio,
                'tabla':tabla
            }
        )
    }

    cargarDatos(datos){
        this.setState({
            nroreten:datos.nroreten,
            op:datos.op,
            fechaop:datos.fechaop,
            importeop:datos.importeop,
            alicuota:datos.alicuota,
            importereten:datos.importereten,
            fechapago:datos.fechapago,
            cuit:datos.cuit,
            razon:datos.razon,
            calle:datos.calle,
            callenro:datos.callenro,
            piso:datos.piso,
            dpto:datos.dpto,
            localidad:datos.localidad,
            provincia:datos.provincia,
            pais:datos.pais,
            concepto:datos.concepto,
            comprobantes:datos.comprobantes,
            importeescrito:datos.importeescrito,
        })
    }

    render(){
        if (this.state.nroreten === ''){
            return <div style={{verticalAlign:'center',
            textAlign:'center',width:'97vw',height:'95vh'}}>
                <Typography>Esperando Comprobante</Typography>
            </div>
        }
        return  <PDFViewer style={{width:'97vw',height:'95vh'}}>
                    <Document style={{width:'97vw',height:'95vh'}}>
                        <Page size='A4'>
                            <View style={{margin:'20pt'}}>
                                <Encabezado
                                    nroreten={this.state.nroreten}
                                ></Encabezado>
                                <AgenteReten
                                ></AgenteReten>
                                <Contribuyente
                                    cuit={this.state.cuit}
                                    razon={this.state.razon}
                                    calle={this.state.calle}
                                    callenro={this.state.callenro}
                                    piso={this.state.piso}
                                    dpto={this.state.dpto}
                                    localidad={this.state.localidad}
                                    provincia={this.state.provincia}
                                    pais={this.state.pais}
                                    importeescrito={this.state.importeescrito}
                                    op={this.state.op}
                                    ejercicio={this.state.ejercicio}
                                ></Contribuyente>
                                <Operacion 
                                    fechaop={this.state.fechaop}
                                    importeop={this.state.importeop}
                                    alicuota={this.state.alicuota}
                                    importereten={this.state.importereten}
                                    fechapago={this.state.fechapago}
                                ></Operacion>
                                <Firmas
                                    fechapago={this.state.fechapago}
                                ></Firmas>
                            </View> 
                        </Page>
                    </Document>
                </PDFViewer>
    }
}

class Operacion extends Component{
    constructor(props){
        super(props);
        this.state={
            importeop:props.importeop,
            importereten:props.importereten
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            importeop:props.importeop,
            importereten:props.importereten
        })
    }

    render(){
        return <View style={{marginTop:'60pt'}}>
            <View>
                <Text style={{fontSize:'10pt'}}>Monto Imponible $ ****{this.state.importeop}</Text>
                
            </View>
            <View style={{marginTop:'10pt'}}>
                <Text style={{fontSize:'10pt'}}>Son $ ****{this.state.importereten}</Text>
            </View>
        </View>
    }
}

class Firmas extends Component{

    constructor(props){
        super(props);
        this.state={
            fechapago:props.fechapago,
            //fecha:props.fechapago !== '' ? new Date(this.desarmarFecha(props.fechapago)): '',
        }
        this.dias={
            0:'Domingo',
            1:'Lunes',
            2:'Martes',
            3:'Miercoles',
            4:'Jueves',
            5:'Viernes',
            6:'Sabado'
        }
    }

    desarmarFecha(fecha){
        let dia = fecha.substring(0,2);
        let mes = fecha.substring(3,5);
        let anio = fecha.substring(6,10);
        return anio + '-' + mes + '-' + dia;
    }

    componentWillReceiveProps(props){
        this.setState({
            fechapago:props.fechapago,
            //fecha:props.fechapago !== ''  ? new Date(this.desarmarFecha(props.fechapago)): '',
        
        })
    }

    render(){
        
        return  <View style={{flexDirection:'row',position:'absolute',top:'300pt'}}>
                    <View style={{width:'250pt'}}>
                        <View style={{textAlign:'center'}}>
                            <Text style={{borderBottom:'1 solid black',fontSize:'10'}}>
                                Ezeiza, {this.state.fechapago}
                            </Text>
                            <Text style={{fontSize:'9'}}>Lugar y Fecha</Text>
                        </View>
                    </View>
                    <View style={{width:'250pt',marginLeft:'50pt',position:'relative',top:'-113pt'}}>
                        <View style={{borderBottom:'1 solid black',textAlign:'center'}}>
                            {/*<Image src={Firma}
                                style={{height:'120pt',width:'105pt',position:'relative',left:'70pt'}}
                            ></Image>*/
                            }
                            <Text style={{fontSize:'6',textAlign:'center'}}>
                                Municipalidad de Ezeiza
                            </Text>
                        </View>
                        <Text style={{fontSize:'9',textAlign:'center'}}>
                            Sello y Firma
                        </Text>
                    </View>
                </View>
    }
}



class Contribuyente extends Component{
    constructor(props){
        super(props);
        this.state={
            cuit:props.cuit,
            razon:props.razon,
            calle:props.calle,
            callenro:props.callenro,
            piso:props.piso,
            dpto:props.dpto,
            localidad:props.localidad,
            provincia:props.provincia,
            pais:props.pais,
            importeescrito:props.importeescrito,
            ejercicio:props.ejercicio,
            op:props.op,
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            cuit:props.cuit,
            razon:props.razon,
            calle:props.calle,
            callenro:props.callenro,
            piso:props.piso,
            dpto:props.dpto,
            localidad:props.localidad,
            provincia:props.provincia,
            pais:props.pais,
            importeescrito:props.importeescrito,
            ejercicio:props.ejercicio,
            op:props.op,
        })
    }

    render(){
        return <View style={{marginTop:'10pt'}}>
            <Text style={{fontSize:'10pt'}} >Recibí de {this.state.razon} con domicilio en {this.state.calle + ' ' + this.state.callenro}
                , {this.state.localidad}, C.U.I.T.:{this.state.cuit} la cantidad de {this.state.importeescrito}
                 en concepto de Tasa Municipal según actuaciones obrantes de Orden de Pago {this.state.op}/{this.state.ejercicio}
            </Text>
        </View>
    }
}

class Encabezado extends Component{
    constructor(props){
        super(props);
        this.state={
            nroreten:props.nroreten
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            nroreten:props.nroreten
        })
    }

    render(){
        return <View style={{flexDirection:'row'}}>
            <View style={{width:'200pt'}}>
                {/*<Image src={Logo}
                    style={{width:'50pt',left:'50pt'}}
                ></Image>*/
                }
            </View>
            <View style={{textAlign:'center',width:'350pt'}}>
                <View>
                    <Text style={{border:'1 solid black', fontSize:'15pt'}}
                    >RECIBO DE RETENCION - Nro. {this.state.nroreten}</Text>
                </View>
                <View>
                    <Text style={{fontSize:'10pt'}}>Tasa Municipal</Text>
                </View>
            </View>
        </View>
    }
}

class AgenteReten extends Component{
    
    render(){
        return <View style={{flexDirection:'row',marginTop:'15pt'}}>
                <View style={{width:'200pt'}}>
                    
                </View>
                <View style={{width:'350pt'}}>
                    <Text style={{borderBottom:'1 solid black',fontSize:'10pt',width:'95'}}
                    >Agente de Retención</Text>
                    <Text style={{fontSize:'10pt'}}>Municipalidad de Almirante Brown</Text>
                    <Text style={{fontSize:'10pt'}}>Rosales 1312</Text>
                    <Text style={{fontSize:'10pt'}}> (1846) - Adrogue</Text>
                    <Text style={{fontSize:'10pt'}}>C.U.I.T.: 33-99900148-9</Text>
                </View>
            </View>
    }
}

